import { type PersonaFisicaDTO } from '@framework/api-client/api/inquiries-compile/schemas/personaFisicaDTO.ts';
import { useMemo } from 'react';
import { ApplicantsTableCell } from '../../../submissions/applicants/ApplicantsTableCell.tsx';
import { mapApplicants } from './utils/applicantColumnUtils.ts';

export interface IDossierApplicantTableCellProps {
  applicants: PersonaFisicaDTO[] | null | undefined;
}

export function DossierApplicantTableCell(
  props: IDossierApplicantTableCellProps,
) {
  const { applicants } = props;

  const rendered = useMemo(() => mapApplicants(applicants), [applicants]);

  if (!rendered) return null;

  return <ApplicantsTableCell applicants={rendered} />;
}
